import { makeSelectors } from '@utils/css';

const stateChangeDurationMs = 200;
const wrapper = "_araw1x1cvd4";
const state = "_arasuf8y92";
const spinner = "_arass5rnxk";
const icon = "_arai1aw4ntj";
const asyncIndicatorSelectors = makeSelectors({
  wrapper,
  state
});

export { asyncIndicatorSelectors, icon, spinner, state, stateChangeDurationMs, wrapper };
import "./_async-indicator.style.linaria.module.css";
//# sourceMappingURL=_async-indicator.style.js.map
